import { httpApi } from '@app/api/http.api'

import { TableTemplate } from '@/store/slices/templates-slice'
import { UsageElement } from '@/features/wizard-page/types'

export type ResetTableData = { index: number; bitIndex: string; dataType: string; defaultValue: string }[]

export type DeviceTemplate = {
  id: string
  name: string
  createdAt: Date
  dataTypes: string
  deviceStatusDataType: string
  deviceStatusIndex: number
  isDeleted: boolean
  isNew: boolean
  resetTableData?: ResetTableData
  monitoredElementParams?: UsageElement[]
  resourceDataType: string
  resourceIndex: number
  deviceBitIndex: number
  resourceLabel: string
  templateConfig: any
  updatedAt: Date
  language: string
}

export type GetTemplateForDevicePayload = {
  deviceId: string
  language: string
}

export type AllTemplatesListFormResponse = {
  id: string
  name: string
  language: any
}

const TEMPLATES = 'templates'

export const updateTemplate = ({ id, ...data }: DeviceTemplate): Promise<void> =>
  httpApi.post<void>(`${TEMPLATES}/updateTemplate/${id}`, { id, ...data }).then(({ data }) => data)

export const createTemplate = (data: DeviceTemplate): Promise<string> =>
  httpApi.post<string>(`${TEMPLATES}/createTemplate`, data).then(({ data }) => data)

export const getAllTemplatesListForm = (): Promise<AllTemplatesListFormResponse[]> =>
  httpApi.get<AllTemplatesListFormResponse[]>(`${TEMPLATES}/form-list`).then(({ data }) => data)

export const getAllTemplatesTable = (): Promise<TableTemplate[]> =>
  httpApi.get<any[]>(`${TEMPLATES}/all-table`).then(({ data }) => data)

export const getFullTemplate = (id: string): Promise<DeviceTemplate> =>
  httpApi.get<DeviceTemplate>(`${TEMPLATES}/${id}`).then(({ data }) => data)

export const getTemplateForDevice = (payload: GetTemplateForDevicePayload): Promise<DeviceTemplate> =>
  httpApi.post<DeviceTemplate>(`${TEMPLATES}/by-device`, payload).then(({ data }) => data)
